<template>
  <v-container>
    <v-row>
      <v-col :cols="cols" v-for="(goal, index) in goalsObj" :key="index">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="odsClick(index)">
              <img
                :src="require(`@/assets/images/goals/${goal.img}.webp`)"
                :class="goalsObj[index].select ? '' : 'grey'"
              />
            </v-btn>
          </template>
          <span>{{goal.tooltip}}</span>
        </v-tooltip>
      </v-col>
      <small class="red--text pt-5 pl-5" v-if="selected.length > 4">
        Recuerda marcar los 4 principales
      </small>
    </v-row>
  </v-container>
</template>

<script>

export default {
    props: ["cols", "goals"],
    data() {
        return {
            goalsObj: [
                { tooltip: "Fin a la Pobreza", img: "goal-01", select: false },
                { tooltip: "Hambre cero", img: "goal-02", select: false },
                { tooltip: "Salud y bienestar", img: "goal-03", select: false },
                { tooltip: "Educación de calidad", img: "goal-04", select: false },
                { tooltip: "Igualdad de género", img: "goal-05", select: false },
                { tooltip: "Agua limpia y saneamiento", img: "goal-06", select: false },
                { tooltip: "Energía asequible y no contaminante", img: "goal-07", select: false },
                { tooltip: "Trabajo decente y crecimiento económico", img: "goal-08", select: false },
                { tooltip: "Industria, innovación e infraestructura", img: "goal-09", select: false },
                { tooltip: "Reducción de las desigualdades", img: "goal-10", select: false },
                { tooltip: "Ciudades y comunidades sostenibles", img: "goal-11", select: false },
                { tooltip: "Producción y consumo responsables", img: "goal-12", select: false },
                { tooltip: "Acción por el clima", img: "goal-13", select: false },
                { tooltip: "Vida submarina", img: "goal-14", select: false },
                { tooltip: "Vida de ecosistemas terrestres", img: "goal-15", select: false },
                { tooltip: "Paz, justicia e instituciones sólidas", img: "goal-16", select: false },
                { tooltip: "Alianzas para lograr objetivos", img: "goal-17", select: false }
            ],
            selected: []
        };
    },
    created() {
        if (this.goals) {
            this.goals.forEach(element => {
                this.goalsObj[element - 1].select = true;
                this.selected.push(element);
            });

        }
    },
    methods: {
        odsClick(index) {
            this.goalsObj[index].select = !this.goalsObj[index].select;
            if (this.goalsObj[index].select) {
                this.selected.push(index + 1);
            } else {
                const element = this.selected.indexOf(index + 1);
                this.selected.splice(element, 1);
            }
            this.$emit("click", this.selected);
        }
    }
};
</script>

<style scoped>
.grey{
    filter: grayscale(100%);
}
img{
    width:45px;
}
</style>
